/**
 * A user as referenced by a notification assignment.
 */
export interface NotificationUser {
  notification_id?: string;
  notificationId?: string;
  user_id?: string;
  userId?: string;
  muted?: boolean;
  created_at?: string;
  createdAt?: string;
}

/**
 * Indexes the notification-assignment response by id, so lookups are O(1) rather
 * than a scan per row.
 */
export const mapAssignmentsResponseToRecord = (
  assignments: NotificationUser[] = [],
): Record<string, string[]> => {
  if (!assignments || !Array.isArray(assignments)) {
    return {};
  }

  return assignments.reduce(
    (result, assignment) => {
      const notificationId = assignment.notification_id || assignment.notificationId;
      const userId = assignment.user_id || assignment.userId;

      if (!notificationId || !userId) {
        return result;
      }

      const currentUsers = result[notificationId] || [];
      if (currentUsers.includes(userId)) {
        return result;
      }

      return {
        ...result,
        [notificationId]: [...currentUsers, userId],
      };
    },
    {} as Record<string, string[]>,
  );
};
